module.exports = __webpack_public_path__ + "img/loader.51b54441.gif";